import { Box, Radio, RadioGroup, FormControlLabel, Select, MenuItem, Popper, Paper, Button, IconButton, FormControl, TextField } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Iconify from '../components/Iconify';
import { useState, useRef } from 'react';

const CustomAmountFilter = ({ value, onChange, fromTable = false }) => {

    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [selectionType, setSelectionType] = useState('before');
    const [singleAmount, setSingleAmount] = useState(value?.amount || '');
    const [startAmount, setStartAmount] = useState(value?.startAmount || '');
    const [endAmount, setEndAmount] = useState(value?.endAmount || '');

    const handleApply = () => {
        if (selectionType === 'before' && singleAmount) {
            onChange({ type: 'before', amount: singleAmount });
        } else if (selectionType === 'after' && singleAmount) {
            onChange({ type: 'after', amount: singleAmount });
        } else if (selectionType === 'between' && startAmount && endAmount) {
            onChange({ type: 'between', startAmount, endAmount });
        }
        setOpen(false);
    };

    const handleClear = () => {
        setSelectionType('');
        setSingleAmount('');
        setStartAmount('');
        setEndAmount('');
        onChange(null);
        setOpen(false);
    };

    const getDisplayText = () => {
        if (!value) return 'Numéro';
        if (value.type === 'before') return `Moin ${value.amount}`;
        if (value.type === 'after') return `Plus ${value.amount}`;
        if (value.type === 'between') return `${value.startAmount} - ${value.endAmount}`;
        return 'Numéro';
    };

    const selectStyles = {
        '&:before': {
            borderBottom: '1px solid #EA5E00',
        },
        '&:after': {
            borderBottom: '2px solid #EA5E00',
        },
        '&:hover:not(.Mui-disabled):before': {
            borderBottom: '2px solid #EA5E00',
        },
        minWidth: 'auto',
        '& .MuiSelect-icon': {
            color: '#EA5E00',
            top: '50%',
            transform: 'translateY(-50%)',
        },
    };

    return (
        <>
            {fromTable ? (
                <FormControl fullWidth variant="standard">
                    <Select
                        ref={anchorRef}
                        displayEmpty
                        sx={selectStyles}
                        onClick={() => setOpen(!open)}
                        value=""
                        open={false}
                        renderValue={() => (
                            <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                                <span>{getDisplayText()}</span>
                                {value?.type && (
                                    <IconButton
                                        size="small"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            handleClear();
                                        }}
                                        sx={{ p: 0, ml: 1 }}
                                    >
                                        <Iconify icon="ic:baseline-clear" sx={{ fontSize: 16 }} />
                                    </IconButton>
                                )}
                            </Box>
                        )}
                    >
                        <MenuItem style={{ display: 'none' }} />
                    </Select>
                </FormControl>
            ) : (
                <Select
                    ref={anchorRef}
                    className="invoiceFiltration_select"
                    size="small"
                    onClick={() => setOpen(!open)}
                    value=""
                    open={false}
                    displayEmpty
                    startAdornment={
                        <Iconify
                            icon="teenyicons:calculator-outline"
                            className="invoiceFiltration_select_icon"
                        />
                    }
                    renderValue={() => (
                        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                            <span>{getDisplayText()}</span>
                            {value?.type && (
                                <IconButton
                                    size="small"
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        handleClear();
                                    }}
                                    sx={{ p: 0, ml: 1 }}
                                >
                                    <Iconify icon="ic:baseline-clear" sx={{ fontSize: 16 }} />
                                </IconButton>
                            )}
                        </Box>
                    )}
                >
                    <MenuItem style={{ display: 'none' }} />
                </Select>
            )}

            <ClickAwayListener
                onClickAway={(event) => {
                    if (!anchorRef.current?.contains(event.target)) {
                        setOpen(false);
                    }
                }}
            >
                <Popper
                    open={open}
                    anchorEl={anchorRef.current}
                    placement="bottom-start"
                    style={{ zIndex: 1300 }}
                >
                    <Paper sx={{ p: 2, width: 400 }}>
                        <RadioGroup
                            value={selectionType}
                            onChange={(e) => setSelectionType(e.target.value)}
                            row
                            sx={{ mb: 2 }}
                        >
                            <FormControlLabel value="before" control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#EA5E00' } }} />} label="Moin" />
                            <FormControlLabel value="after" control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#EA5E00' } }} />} label="Plus" />
                            <FormControlLabel value="between" control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#EA5E00' } }} />} label="Entre" />
                        </RadioGroup>

                        {selectionType !== 'between' ? (
                            <TextField
                                label="Numéro"
                                value={singleAmount}
                                onChange={(e) => setSingleAmount(e.target.value)}
                                type="number"
                                fullWidth
                                size="small"
                            />
                        ) : (
                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <TextField
                                    label="Numéro de début"
                                    value={startAmount}
                                    onChange={(e) => setStartAmount(e.target.value)}
                                    type="number"
                                    size="small"
                                />
                                <TextField
                                    label="Numéro de fin"
                                    value={endAmount}
                                    onChange={(e) => setEndAmount(e.target.value)}
                                    type="number"
                                    size="small"
                                />
                            </Box>
                        )}

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
                            <Button className="secondary_button" onClick={handleClear}>Effacer</Button>
                            <Button className="primary_button" onClick={handleApply}>Appliquer</Button>
                        </Box>
                    </Paper>
                </Popper>
            </ClickAwayListener>
        </>
    );
};

export default CustomAmountFilter;